import QueueIcon from '@mui/icons-material/Queue';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';



export const TabsData = [
    {
      displayName: "Open",
      value: 0,
      label: "label_open"
    },
    {
      displayName: "Closed",
      value: 1,
      label: "label_closed"

    },
    {
      displayName: "All",
      value: 2,
      label: "label_all"
    }
  ];

export const RequestTypeSale = [
  {
    value: 0,
    label: 'Import',
    disable: false
  },
  {
    value: 1,
    label: "Export",
    disable: false
  },
  {
    value: 2,
    label: 'Return',
    disable: true
  }
]

export const TechAssigness = [
  {label: 'nhut.mai'},
  {label: 'son.hoang'},
  {label: 'trang.doan'},
  {label: 'phung.hoang'}
];

export const SaleAssigness = [
  {label: 'nhut.mai'}
];

export const OpenRes = [
  {
    id: 2,
    assignee: "Thư",
    date: '2024-03-04',
    status: "Packed & On Ship",
    request_type: 1
  }
]

export const CancelRes = [
  {
    Id: 1,
    Assignee: "Toàn",
    Date: '2024-03-15'
  }
]

export const AllRes = [
  {
    Id: 2,
    Assignee: "Lê",
    Date: '2024-03-15'
  }
]

export const bottom_nav = [
  {
    label: 'Tasks',
    icon: <LowPriorityIcon />,
    path: '/requests',
  },
  {
    label: 'Assigned',
    icon: <ReceiptLongIcon />,
    path: '/assigned',
  },
  {
    label: 'Create Request',
    icon: <QueueIcon />,
    path: '',
  }
];

export const Statuses = [
  {
    title: "Init",
    value: 0
  },
  {
    title: "Qc",
    value: 1
  },
  {
    title: "Stock",
    value: 2
  },
  {
    title: "Sold",
    value: 3
  },
  {
    title: "Transition",
    value: 4
  }
]


export const RequestStep0 = [
  'Request Made',
  'Confirm and Preparing',
  'Packed & Ship',
  'Request Completed',
];

export const RequestStep1 = [
  'Request Made',
  'Confirm',
  'Packed & Ship',
  'Request Completed',
]

export const RequesTypeConvert = {
  0: 'send devices',
  2: 'Return Devices',
  1: 'receive devices'
}

export const AssignedTypeConvert = {
  0: 'send devides',
  2: 'Return Devices',
  1: 'get devices'
}


